import { Config } from '../Config';

export enum LogLevel {
  Trace,
  Debug,
  Info,
  Warn,
  Error,
}

export class Logger {
  uiLogLevel: LogLevel;

  constructor() {
    this.uiLogLevel = LogLevel[Config.UI_LOG_LEVEL as keyof typeof LogLevel];
  }

  trace(message: string) {
    if (LogLevel.Trace >= this.uiLogLevel) {
      console.trace(message);
    }
  }

  debug(message: string) {
    if (LogLevel.Debug >= this.uiLogLevel) {
      console.debug(message);
    }
  }

  info(message: string) {
    if (LogLevel.Info >= this.uiLogLevel) {
      console.info(message);
    }
  }

  warn(message: string) {
    if (LogLevel.Warn >= this.uiLogLevel) {
      console.warn(message);
    }
  }

  error(message: string) {
    if (LogLevel.Error >= this.uiLogLevel) {
      console.error(message);
    }
  }
}

export const logger = new Logger();
